import { adminHttpClient } from '../commons/adminHttpClient'
import { BenefitDesignStatus } from 'domain/benefit/benefitDesignStatus'

export type RenewalPlanPeriodResponse = {
  id: string
  startDate: string
  endDate: string
  status: BenefitDesignStatus
  groupHealthPlanId: string
  notificationDate?: string
}

const getRenewalPlanPeriod = (): Promise<RenewalPlanPeriodResponse> => {
  return adminHttpClient.get(`/Benefit/RenewalPlanPeriod`)
}

export default getRenewalPlanPeriod
